import type { CompanyVO, CollegeRecruitment, CompanyStatistics, CompanyImages, QichachaCompany, QichachaVO } from '../../services/company';
import { requestGetCompanyInfoById, getCompanyJobStatistics, getImageListData, getCollegePositionForStudent, requestGetQichachaByCompanyId2 } from '../../services/company';
import { useState, useEffect } from 'react';
import { Layout, Row, Col, Image, Carousel, List, Space, Avatar, Tag, Divider, Menu, Tooltip, Button, Card, Descriptions, Tabs, Popover, Typography } from 'antd';
import { useParams } from 'react-router-dom';
import { IMAGE_URL, IMAGE_ERRER } from '../../config/index'
import { createFromIconfontCN } from '@ant-design/icons';
import {
  WarningOutlined,
  ShareAltOutlined,
  WechatOutlined,
  CopyOutlined,
  ClockCircleFilled,
  RestFilled,
  HomeFilled
} from '@ant-design/icons';
import MapComponent from '../../MapContainer';

// import { useModel, history } from 'umi';
export interface Props {
  companyId?: number;
  collegeId?: number;
}
const { Header, Content, Footer } = Layout;
const { Paragraph } = Typography;
// 调用图标 ciconfont.cn
const IconFont = createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/c/font_3869023_s6kx5b2eglj.js',
});

const CompanyDetailView = () => {
  const params = useParams();
  let stringUrl = 'https://student.hjiuye.com/company/'

  if (params && params.id != undefined && params.collegeId && params.activeKey) {
    stringUrl = stringUrl+params.id+'/'+params.collegeId+'/'+params.activeKey
  }else if (params && params.id != undefined) {
    stringUrl = stringUrl+params.id
  }
  window.location.assign(stringUrl)
  const [companyId, setCompanyId] = useState<string>('0');
  const [collegeId, setCollegeId] = useState<string>('2664');
  const [defaultActiveKey, setDefaultActiveKey] = useState<string>('1');

  const [companyInfoDetail, setCompanyInfoDetail] = useState<CompanyVO>();
  const [qichachaCompany, setQichachaCompany] = useState<QichachaVO>();
  const getQichachaCompanyInfo = async () => {
    const res = await requestGetQichachaByCompanyId2({ companyId: companyInfoDetail?.id, companyName: companyInfoDetail?.fullName });
    if (res.code == 1) {
      setQichachaCompany(res.data)
    }
  }
  const getCompanyInfo = async () => {
    const res = await requestGetCompanyInfoById({ id: parseInt(companyId) });
    if (res.code == 1) {
      setCompanyInfoDetail(res.data)
    }
    getImageListDatas()
  }
  const [companyImages, setCompanyImages] = useState<CompanyImages[]>();

  const getImageListDatas = async () => {
    const res = await getImageListData({ companyId: parseInt(companyId) });
    if (res.code == 1) {
      setCompanyImages(res.data)
    }
    getJobStatistics()
  }

  const [companyStatistics, setCompanyStatistics] = useState<CompanyStatistics>();
  const getJobStatistics = async () => {
    const res = await getCompanyJobStatistics({ companyId: parseInt(companyId), collegeId: parseInt(collegeId) }, false);
    if (res.code == 1 && res.data && res.data.length >= 1) {
      setCompanyStatistics(res.data[0])
    }
    getPositionList()
  }

  const [collegeRecruitmentList, setCollegeRecruitmentlList] = useState<CollegeRecruitment[]>();
  const getPositionList = async () => {
    const res = await getCollegePositionForStudent({ companyId: parseInt(companyId), collegeId: parseInt(collegeId), pageSize: 10000, current: 1 });
    if (res.code == 1) {
      setCollegeRecruitmentlList(res.data)
    }

  }

  useEffect(() => {
    if (companyId && companyId != '0') {
      getCompanyInfo()
    }
  }, [companyId]);
  useEffect(() => {
    if (companyInfoDetail && companyInfoDetail?.id != 0 && companyInfoDetail?.fullName != undefined) {
      getQichachaCompanyInfo()
    }
  }, [companyInfoDetail]);

  useEffect(() => {
    // if (location.host.indexOf('https://www.hjiuye.com')>=0) {
    //   let stringUrl = 'https://student.hjiuye.com/company/'
    //   if (params && params.id != undefined && companyId != params.id) {
    //     stringUrl = stringUrl+params.id
    //   }
    //   if (params && params.id != undefined && companyId != params.id && params.collegeId && params.activeKey) {
    //     stringUrl = stringUrl+'/'+params.collegeId+'/'+params.activeKey
    //   }
    //   window.stop()
    //   window.open(stringUrl)
    //   return;
    // }
    // if (params && params.id != undefined && companyId != params.id) {
    //   setCompanyId(params.id)
    // }
    // if (params && params.id != undefined && companyId != params.id && params.collegeId && params.activeKey) {
    //   setCollegeId(params.collegeId)
    //   setDefaultActiveKey(params.activeKey)
    // }
  }, [params]);

  const companyImgs = () => {
    const html = [];
    if (companyImages && companyImages.length > 0) {
      for (const item of companyImages) {
        if (item != undefined && item.id != undefined) {
          html.push(
            <Image
              style={{ objectFit: 'cover', borderRadius: 12 }}
              placeholder={true}
              width={268} height={130} src={item.imagePath == undefined ? showUrl(item.tencentCos?.tencentUrl) : showUrl(item.imagePath)} />
          );
        }
      }
    }
    return html;
  }
  //图片 或 文件对象链接
  const showUrl = (urlString?: string) => {
    if (urlString == undefined) {
      return IMAGE_ERRER;
    }
    return urlString && (urlString.indexOf("http") == 0) ? urlString : IMAGE_URL + urlString;
  }

  const jobsalaryStyle = {
    color: '#fe574a'
  };
  const getJobPaySalary = (item: CollegeRecruitment) => {
    const jobType = item?.jobTypeList && item?.jobTypeList.length >= 1 ? item?.jobTypeList[0] : undefined;
    if (jobType && jobType?.id == 1) {
      return (<div style={jobsalaryStyle}>{item.totalIncomeStart?.content}-{item.totalIncomeEnd?.content}/月</div>)
    } else if (jobType && jobType?.id == 2) {
      return (<div style={jobsalaryStyle}>{item.totalIncomeStart?.content}-{item.totalIncomeEnd?.content}/月</div>)
    } else if (jobType && jobType?.id == 3) {
      if (item.payType?.id == 1) {
        return (<div style={jobsalaryStyle}>{item.paySalary}/小时</div>)
      } else if (item.payType?.id == 2) {
        return (<div style={jobsalaryStyle}>{item.paySalary}/天</div>)
      } else if (item.payType?.id == 3) {
        return (<div style={jobsalaryStyle}>{item.paySalary}/月</div>)
      }
    }
  }

  return (
    <Layout style={{ background: 'linear-gradient(#e4f1f1 0px, #f2f4f7 80%, #f6f6f8 100%)', minHeight: '100vh' }}>

      {/* 页面通用头部header */}
      <Header>
        <div className="logo" />
        <Menu
          theme="dark"
          mode="horizontal"
          defaultSelectedKeys={['2']}
        />
      </Header>

      {/* 内容区域 */}
      <Content>
        <div style={{ padding: '30px 0', background: 'linear-gradient(90deg,#3b526a 0,#386d88 100%)' }}>
          <Row justify="center">
            <Col style={{ width: 1200, margin: '0 auto' }}>
              <div >
                <div style={{ maxWidth: 665, float: 'left' }}>
                  <Space size={24}>
                    <div>
                      <Image
                        width={100}
                        height={100}
                        src={showUrl(companyInfoDetail?.logo)}
                        fallback={IMAGE_ERRER}
                        style={{ borderRadius: 12 }}
                        preview={false}
                      />
                    </div>
                    <Space direction='vertical' size={15}>
                      <div style={{ fontSize: 28, color: '#ffffff', fontWeight: 600 }}>
                        {companyInfoDetail?.fullName}
                      </div>
                      <div style={{ color: '#ffffff' }}>
                        <Space size={0} split={<Divider type="vertical" style={{ backgroundColor: '#ffffff' }} />}>
                          {companyInfoDetail?.location && <span>{companyInfoDetail?.location?.showText}</span>}
                          {companyInfoDetail?.companyType && <span>{companyInfoDetail?.companyType?.content}</span>}
                          {companyInfoDetail?.companySize && <span>{companyInfoDetail?.companySize?.content}</span>}
                          {companyInfoDetail && companyInfoDetail?.companyIndustryList && companyInfoDetail?.companyIndustryList.length >= 1 && companyInfoDetail?.companyIndustryList.map((item, index) => (
                            <span key={index}>{item.content}</span>
                          ))}
                        </Space>
                      </div>
                    </Space>
                  </Space>
                </div>
                <div style={{ textAlign: 'right', float: 'right', fontSize: 15, verticalAlign: 'middle' }}>
                  <Space style={{ color: '#fff', fontSize: 35, fontWeight: 500 }} >
                    {companyStatistics && companyStatistics?.jobNum != undefined && <span style={{ marginRight: 30 }}>{companyStatistics?.jobNum}<span style={{ fontSize: 15, marginLeft: 6, fontWeight: 'normal' }}>在招职位</span></span>}
                    {companyStatistics && companyStatistics?.recruitmentNum != undefined && <span>{companyStatistics?.recruitmentNum}<span style={{ fontSize: 15, marginLeft: 6, fontWeight: 'normal' }}>需求人数</span></span>}
                  </Space>
                  <div style={{ marginTop: 20 }}>
                    {/* <div style={{ marginTop: 40, padding: '0 15px' }}>
                    </div> */}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
        <div style={{ width: 1200, margin: '24px auto 0 auto' }}>
          <Tabs onTabClick={(key: string) => {
            setDefaultActiveKey(key)
          }} activeKey={defaultActiveKey} size='large' tabBarStyle={{ backgroundColor: '#fff', padding: '0 24px', borderRadius: 12, marginBottom: 0 }}
            tabBarExtraContent=
            {<Space>
              {/* <Tooltip title="校招违规举报">
                <Button type='primary' icon={<WarningOutlined />} size='small' ghost />
              </Tooltip>
              <Tooltip title="分享">
                <Button type='primary' icon={<ShareAltOutlined />} size='small' ghost />
              </Tooltip>
              <Tooltip title="小程序访问">
                <Button type='primary' icon={<WechatOutlined />} size='small' ghost />
              </Tooltip> */}
              {/* <Tooltip title="复制链接">
                <Button type='primary' icon={<CopyOutlined />} size='small' ghost />
              </Tooltip> */}
              <Button type='primary' size='small' ghost >
                <Paragraph
                  copyable={{
                    text: location.href,
                    icon: [<CopyOutlined key="copy-icon" />],
                    tooltips: ['复制链接']
                  }}
                >
                </Paragraph>
              </Button>
            </Space>}
          >
            <Tabs.TabPane tab="单位信息" key="1">
              <div style={{ width: 1200, margin: '0 auto' }} >
                <Row style={{ marginTop: 24 }}>
                  <div >
                    <Col >
                      <Row >
                        <Col style={{ width: 884 }}>
                          <Card style={{ borderRadius: 12 }} bodyStyle={{ padding: '6px 0 0' }} >
                            <Card title='单位介绍' bordered={false} headStyle={{ background: '#fff', borderBottom: 0 }} bodyStyle={{ padding: '0 24px', minHeight: '120px', maxHeight: '300px', overflow: 'auto' }}>
                              {/* <div>{companyInfoDetail?.describle}</div> */}
                              <div dangerouslySetInnerHTML={{ __html: "" + companyInfoDetail?.describle }}></div>
                              {/* <div><pre>{companyInfoDetail?.describle}</pre></div> */}
                            </Card>

                            {companyImages && companyImages.length >= 1 &&
                              <Card title="单位相册" bordered={false} headStyle={{ background: '#fff', borderBottom: 0 }} bodyStyle={{ padding: '0 24px' }}>
                                <Space size={3} wrap> {companyImgs()}</Space>
                              </Card>
                            }

                            <Card title='工商信息' bordered={false} headStyle={{ borderBottom: 0 }} bodyStyle={{ padding: '0 24px' }}>
                              <div >
                                <Descriptions layout="vertical" bordered size='small'>
                                  <Descriptions.Item label="企业名称">{qichachaCompany?.qichachaCompany?.name}</Descriptions.Item>
                                  <Descriptions.Item label="法定代表人">{qichachaCompany?.qichachaCompany?.operName}</Descriptions.Item>
                                  <Descriptions.Item label="注册资本">{qichachaCompany?.qichachaCompany?.registCapi}</Descriptions.Item>
                                  <Descriptions.Item label="成立日期" >
                                    {qichachaCompany?.qichachaCompany?.startDate?.substring(0, 11)}
                                  </Descriptions.Item>
                                  <Descriptions.Item label="注册地址 ">{qichachaCompany?.qichachaCompany?.address}</Descriptions.Item>
                                  <Descriptions.Item label="登记状态">{qichachaCompany?.qichachaCompany?.status}</Descriptions.Item>
                                  <Descriptions.Item label="统一社会信用代码" span={3} >
                                    {qichachaCompany?.qichachaCompany?.creditCode}
                                  </Descriptions.Item>
                                  <Descriptions.Item label="经营范围" span={3}>
                                    {qichachaCompany?.qichachaCompany?.scope}
                                  </Descriptions.Item>
                                </Descriptions>
                              </div>
                            </Card>
                            <Card title='单位地址' style={{ borderRadius: 12 }} headStyle={{ borderBottom: 0 }} bordered={false} bodyStyle={{ paddingTop: 0 }}>
                              <div>
                                {companyInfoDetail?.position}
                              </div>
                              {companyInfoDetail?.lat != undefined && companyInfoDetail?.lat != '' && companyInfoDetail?.lon != undefined && companyInfoDetail?.lon != '' && <div style={{ width: '100%', height: '200px', border: '#ccc solid 1px', }} id="dituContent">
                                {companyInfoDetail?.lat != undefined && companyInfoDetail?.lat != '' && companyInfoDetail?.lon != undefined && companyInfoDetail?.lon != '' && <MapComponent lat={companyInfoDetail?.lat} lng={companyInfoDetail?.lon}></MapComponent>}
                              </div>}
                            </Card>
                          </Card>

                          {/* <div><div dangerouslySetInnerHTML={{ __html: "" + companyInfoDetail?.describle }}></div></div> */}
                          {/* 
                          <div>
                            {companyInfoDetail && companyInfoDetail?.labelList && companyInfoDetail?.labelList.length >= 1 && companyInfoDetail?.labelList.map((item, index) => (

                              // <Button key={index}>{item.content}</Button>
                              <Tag key={index} color="gold">{item.content}</Tag>
                            ))}
                          </div> */}
                        </Col>
                        <Col style={{ width: 292, marginLeft: 24 }} >
                          <Card title='工作时间及福利' style={{ borderRadius: 12 }}>
                            <div>
                              <Space direction='vertical' >
                                <span style={{ fontSize: 13 }}><ClockCircleFilled style={{ color: '#cccccc', fontSize: 14, marginRight: 10 }} />{companyInfoDetail?.restTime?.content}</span>
                                <span style={{ fontSize: 13 }} ><RestFilled style={{ color: '#cccccc', fontSize: 14, marginRight: 10 }} />{companyInfoDetail?.overtimeCondition?.content}</span>
                              </Space>
                              <Space align="center" wrap style={{ marginTop: 16 }} >
                                {companyInfoDetail && companyInfoDetail?.welfarelList && companyInfoDetail?.welfarelList.length >= 1 && companyInfoDetail?.welfarelList.map((item, index) => (
                                  // eslint-disable-next-line react/no-array-index-key
                                  // <Button key={index}>{item.content}</Button>
                                  <span style={{ background: '#f8f8f8', padding: '4px 15px', textAlign: 'center', borderRadius: 4, margin: '12px 4px 0 4px', maxWidth: '100%', width: 105, float: 'left', lineHeight: '20px' }} key={index}>{item.content}</span>
                                ))}
                              </Space>
                            </div>
                          </Card>
                        </Col>
                      </Row>
                    </Col>
                  </div>
                </Row>
              </div>
            </Tabs.TabPane>
            <Tabs.TabPane tab="在招职位" key="2">
              <div style={{ marginTop: 24 }}>

                <List
                  grid={{ gutter: 16, column: 2 }}
                  itemLayout="vertical"
                  size="large"
                  // pagination={{
                  //   onChange: page => {
                  //     console.log(page);
                  //   },
                  //   pageSize: 100,
                  // }}
                  dataSource={collegeRecruitmentList}
                  renderItem={item => (
                    <List.Item
                      style={{ padding: 0 }}
                    >
                      <Card
                        hoverable
                        style={{ borderRadius: 12 }}
                        title={<a onClick={() => {
                          window.open('/job/' + item.id + '/' + collegeId)
                        }}>{item.positionName}</a>}
                        extra={
                          <Button onClick={() => {
                            window.open('/job/' + item.id + '/' + collegeId)
                          }} type="primary" shape='round'>
                            查看详情
                          </Button>
                        }>
                        <List.Item.Meta
                          style={{ marginBottom: 0 }}
                          // avatar={<Avatar src={item.companyInfo?.logoPath} />}
                          // title={<a onClick={() => {
                          //   window.open('/job/' + item.id)
                          // }}>{item.positionName}</a>}
                          description={<div>
                            <Space size={10} wrap>
                              <span style={{ fontSize: 18, fontWeight: 500 }}>{getJobPaySalary(item)}</span>
                              {item && item?.workPlaceList && item?.workPlaceList.length >= 1 && item?.workPlaceList.map((item, index) => (
                                index <= 0 ? <span key={index}><IconFont type="icon-weizhi" /> {item.showText}</span> : ''
                              ))}
                              {item.postNum != undefined && item.recruitmentGroup?.recruitmentNum == undefined && <span ><IconFont type="icon-zongrenshu" /> {item.postNum}人</span>}
                              {item.postNum == undefined && item.recruitmentGroup?.recruitmentNum != undefined && <span ><IconFont type="icon-zongrenshu" /> {item.recruitmentGroup?.recruitmentNum}人</span>}
                              {item.degreeStart && <span ><IconFont type="icon-xueli" /> {item.degreeStart?.content}</span>}
                              {item && item?.jobTypeList && item?.jobTypeList.length >= 1 && item?.jobTypeList.map((item, index) => (
                                <span key={index}><IconFont type="icon-qidongzhaopinshenqing" /> {item.content}</span>
                              ))}

                              {/* {item.degreeDemand && <Button >{item.degreeDemand?.content}</Button>} */}
                            </Space>
                          </div>}
                        />
                      </Card>

                      {/* {item.positionName} */}
                    </List.Item>
                  )}
                />
              </div>
            </Tabs.TabPane>
          </Tabs>
        </div>

      </Content>
      <Footer style={{ textAlign: 'center', marginTop: 24, background: '#0000' }}>慧就业提供技术支持</Footer>
    </Layout>
  );
};

export default CompanyDetailView;